// extracted by mini-css-extract-plugin
export default {"container":"nq-z","ratingLayout":"oq-z","ratingLabel":"pq-z","nonInteractiveRatingLabel":"qq-z"};